<template>
  <div class="content">
    <div class="container">
      <button
        class="float-right btn btn-light"
        @click="$router.go(-1)"
      >
        Back Fulfilment
      </button>
      <h1 class="mb-5">
        Fulfillment #{{ id_order }}
      </h1>
      <card-box>
        <card-title>Order Details ({{ items.length }} Orders)</card-title>
        <table class="mt-3 table table-striped  table-hover w-100 d-block d-md-table table-responsive">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Country</th>
              <th>Quantity</th>
              <th class="text-right">
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
            >
              <th width="120">
                <router-link :to="{name:'order_detail',params:{id:item.id}}">
                  {{ item.id }}
                </router-link>
              </th>
              <td class="product">
                {{ item.name }}
              </td>
              <td class="product">
                {{ item.country }}
              </td>
              <td
                width="80"
                class="align-middle"
              >
                {{ item.quantity }} item(s)
              </td>
              <td class="align-middle text-right">
                ${{ item.price }}
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <div class="text-right">
                  <strong>Total:</strong>
                </div>
              </td>
              <td colspan="2">
                <div class="text-right">
                  <strong> ${{ order.payment_total }}</strong>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--  <hr>-->

        <button
          v-if="order.status == 0"
          :disabled="disable == 1"
          class="btn btn-block btn-success"
          @click="paynow"
        >
          {{ disable == ''? 'PAY NOW':'WAITING...' }}
        </button>
        <span
          v-if="order.status == 1"
          class="btn btn-block btn-outline-success"
        ><i class="dripicons-checkmark" /> PAID</span>
      </card-box>
    </div>
  </div>
</template>

<script>
    import CardBox from "@/components/CardBox";
    import CardTitle from "@/components/CardTitle";

    export default {
        name: "FulfillmentDetail",
        components: {CardTitle, CardBox},
        data: function () {
            return {
                disable: 0,
                id_order: 0,
                order: {},
                items: []
            }
        },
        mounted: function () {
            this.id_order = this.$route.params.id
            this.detail()
        },
        methods: {
            paynow: function () {
                this.disable = 1
                this.$http.get(this.$config.api + 'fulfillment/initcheckout/' + this.id_order).then(function (res) {
                    //  console.log(res)
                    window.location.href = res.data.url
                })
            },
            detail: function () {
                let vm = this
                this.$http.get(this.$config.api + 'fulfillment/' + this.id_order).then(function (res) {
                    vm.order = res.data.order
                    vm.items = res.data.items
                })
            }
        }
    }
</script>

<style scoped>

</style>